module.exports = new Promise(resolve => {
    const hostname = window.location.hostname
    let remoteUrl = 'https://'

    if (!hostname.includes('local')) {
      remoteUrl += 'userManagement-'
    }

    remoteUrl += hostname

    if (hostname.includes('local')) {
      remoteUrl += ':3008'
    }

    remoteUrl += '/userManagementRemoteEntry.js'

    if (hostname.includes('rotw.uplight.io')) {
      const envName = hostname.split('.')[1]
      remoteUrl = 'https://storage.googleapis.com/usermanagement-upsuite-' + envName + '-rotw/build/userManagementRemoteEntry.js'
    }

    if (hostname.includes('upsuite.uplightplatform.com')) {
      remoteUrl = 'https://storage.googleapis.com/usermanagement-upsuite-prd-rotw/build/userManagementRemoteEntry.js'
    }

    const script = document.createElement('script')
    script.src = remoteUrl
    script.onload = () => {
      const proxy = {
        get: (request) => window.userManagement.get(request),
        init: (arg) => {
          try {
            return window.userManagement.init(arg)
          } catch(e) {
            console.log('userManagement remote container already initialized')
          }
        }
      }
      resolve(proxy)
    }
    document.head.appendChild(script);
  })
  ;